module.exports = __webpack_public_path__ + "img/sourcingReport.3f80069c.svg";